// extracted by extract-css-chunks-webpack-plugin
module.exports = {"shadowBox":"app-components-kit-shadowbox-shadowbox--shadowBox","fullOnMobile":"app-components-kit-shadowbox-shadowbox--fullOnMobile"};